import React from "react"
//import I18n from "i18n-js/index.js.erb"
class GroupContractRate extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  render() {
    return (
      <div className="group-contract-rate">
        <div className="form-group">
          <label>{I18n.t('code')}</label>
          <div>{this.props.rate.code}</div>
        </div>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>{I18n.t('status')} <span className="ss-help help" title={I18n.t('group_contract_rate_status_helper_text')}></span></label>
          <div className="form-inline">
            {
              this.props.read_only
                ?
                I18n.t(this.props.status || 'disabled')
                :
                <select name="status" value={this.props.status || 'disabled'} onChange={this.onChange} className="form-control">
                  <option value="enabled">{I18n.t('enabled')}</option>
                  <option value="disabled">{I18n.t('Disabled')}</option>
                </select>
            }
          </div>
        </div>
      </div>
    );
  }

  onChange(event) {
    if (typeof this.props.onChange == 'function') {
      var group_contract_rate = {
        id: this.props.id,
        rate_id: this.props.rate_id || this.props.rate.id,
        status: this.props.status
      };

      group_contract_rate[event.target.name] = event.target.value;

      this.props.onChange(group_contract_rate);
    }
  }
};
export default GroupContractRate